import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Utilities_ds_get_warehouses_by_warehouseIdsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouseIds: number[] }): 
  Promise<{ result: { Id?: number, DefaultPickDestinationLocationId?: number, DefaultReceivingLocationId?: number, Name?: string, Notes?: string, TimeZoneId?: string, TypeId?: number, Type?: { Name?: string }, DefaultPickDestinationLocation?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseIds)) {
      missingRequiredInParams.push('\'warehouseIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Utilities/datasources/ds_get_warehouses_by_warehouseIds/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { warehouseIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, DefaultPickDestinationLocationId?: number, DefaultReceivingLocationId?: number, Name?: string, Notes?: string, TimeZoneId?: string, TypeId?: number, Type?: { Name?: string }, DefaultPickDestinationLocation?: { Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseIds)) {
      missingRequiredInParams.push('\'warehouseIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Utilities/datasources/ds_get_warehouses_by_warehouseIds/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouseIds: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, DefaultPickDestinationLocationId?: number, DefaultReceivingLocationId?: number, Name?: string, Notes?: string, TimeZoneId?: string, TypeId?: number, Type?: { Name?: string }, DefaultPickDestinationLocation?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseIds)) {
      missingRequiredInParams.push('\'warehouseIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Utilities/datasources/ds_get_warehouses_by_warehouseIds/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      warehouseIds: number[]    }) {
        if(isNil(inParams.warehouseIds)) {
          return true; 
        }
      return false;
    }
}
